import { Injectable} from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

// import { ErrorModel } from './error.model';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class HttpService { 
        
    constructor(private _http: Http) {
    }
    
    tokenAPI: string;

    httpGet(url:string, userRoles?: any): Observable<Response>
    {
        let token = this.tokenAPI;
        let headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token, 'UserRoles': userRoles });

        let resp = this._http.get(url, {headers})     
        .catch(this.errorCustomHandler);
        return resp;
    }

    httpGetFile(url:string, contenType: string, userRoles?: any): Observable<Response>
    {
        let token = this.tokenAPI;
        let headers = new Headers({'Content-Type': contenType, 'Authorization': 'Bearer ' + token, 'UserRoles': userRoles });
        let options = new RequestOptions({
            responseType: ResponseContentType.Blob,
            headers: headers
        });

        let resp = this._http.get(url, options)     
        .catch(this.errorCustomHandler);
        return resp;
    }

    httpPost(url:string, body: any, userRoles?: any, accessToken:string = null): Observable<Response>
    {
        let token = '';
        if(accessToken){
            token = accessToken;
        }
        else{
            token = this.tokenAPI;
        }        
        let headers = new Headers({'Content-Type': 'application/json', 
                                    'Authorization': 'Bearer ' + token ,
                                    'UserRoles': userRoles
        });
        return this._http.post(url,body, {headers}).catch(this.errorCustomHandler);
        
    }

    httpPut(url:string, body: any): Observable<Response>
    {
        let token = this.tokenAPI;
        let headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token });
        return this._http.put(url,body,{headers}).catch(this.errorCustomHandler);
    }

    httpDelete(url:string): Observable<Response>
    {
        let token = this.tokenAPI;
        let headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token });

        let resp = this._http.delete(url, {headers})     
        .catch(this.errorCustomHandler);
        return resp;
    } 

    httpPatch(url:string, body: any): Observable<Response>
    {
        let token = this.tokenAPI;
        let headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token });
        return this._http.patch(url,body,{headers}).catch(this.errorCustomHandler);
    }
   
    errorCustomHandler(error:Response):Observable<Response>{
        if(error.status === 401 && error.url.endsWith('GenerateToken')){
            return Observable.throw(error || 'Server error');
        }
        if(error.status === 401){
            console.log('Redirect to Home: Error 401 unauthorized');                       
            window.location.href = window.location.origin;   
        }
        return Observable.throw(error || 'Server error');
    }
 
    setToken(id_token: string): void {
        this.tokenAPI = id_token;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/http.service.ts